import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface PreLaunchRequest {
  email: string;
  countryCode: string;
  phoneNumber: string;
  countryId: number;
  zipCode: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly preLaunchUrl = 'https://internalws.dryo.io/dryows/user/preLaunch';

  constructor(private http: HttpClient) {}

  notify(data: any) {
    const zipCodeValue = data && data.zipCode !== undefined && data.zipCode !== null
      ? String(data.zipCode).trim()
      : '';
    const zipcodeValue = data && data.zipcode !== undefined && data.zipcode !== null
      ? String(data.zipcode).trim()
      : '';
    const zipValue = data && data.zip !== undefined && data.zip !== null
      ? String(data.zip).trim()
      : '';
    const resolvedZipCode = zipCodeValue || zipcodeValue || zipValue;

    const payload: PreLaunchRequest = {
      email: data && data.email ? String(data.email) : '',
      countryCode: data && data.countryCode ? String(data.countryCode).replace('+', '') : '1',
      phoneNumber: data && data.phoneNumber ? String(data.phoneNumber) : '',
      countryId: data && data.countryId ? Number(data.countryId) : 231,
      zipCode: resolvedZipCode
    };

    return this.http.post(this.preLaunchUrl, payload);
  }
}


